import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/milao-navigli-vertical.mp4")